import { Provider } from '@angular/core';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import { PROBATE_DATE_FORMATS } from '../constants';

export const PROBATE_DATE_FORMATS_PROVIDER: Provider[] = [
  { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
  { provide: MAT_DATE_FORMATS, useValue: PROBATE_DATE_FORMATS },
];
